import GutterBlockTypes, { TABLE_ACTION_EVENT } from '../../../types/GutterBlockTypes';
export default function makeDeselectTable(store) {
  return {
    deselectTable: function deselectTable(editor) {
      var tableId = store.getItem('lastFocusedTableId');
      var table = editor.getTable(tableId);

      if (table) {
        editor.command('updateGutterBlock', {
          gutterBlockType: GutterBlockTypes.ALL_BLOCKS,
          nodeId: table.key,
          origin: TABLE_ACTION_EVENT
        });
      }

      var cellToFocus = editor.getSelectedTableCells().first();
      store.updateItem('lastFocusedTableId', undefined);
      store.updateItem(tableId, {});

      if (editor.value.selection.isUnset && cellToFocus) {
        var textNode = cellToFocus.getFirstText();
        editor.moveTo(textNode.key, 0);
      }

      return editor;
    }
  };
}